<div class="background {{ backgroundColor }} {{ size }}">
  <i class="uil uil-{{ icon }}"></i>
</div>
